import { SxProps } from '@mui/system'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import { theme } from 'src/providers/ThemeProvider'
import { alert, colors } from 'src/providers/globalVars'

type DialogElements = {
  root: SxProps
  title: SxProps
  closeIcon: SxProps
}

export const DialogStyles = (_type: AlertType): DialogElements => {
  return {
    root: {
      color: theme.corporate.errorColor,

      '& .MuiDialog-paper': {
        borderRadius: '8px'
      },

      '&.warning, &.info, &.error': {
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            padding: 0
          }
        }
      }
    },
    title: {
      '& div': {
        display: 'flex',
        '& span, & h5': {
          display: 'flex',
          alignItems: 'center'
        },

        '& h6': {
          fontFamily: theme.corporate.primaryFont,
          fontSize: '18px',
          fontWeight: 700,
          lineHeight: '20px'
        }
      },
      '&.warning, &.info, &.error': {
        padding: '20px',
        height: 'auto',
        color: colors.white01
      },
      '&.info': {
        background: alert.info.titleBackground
      },
      '&.error': {
        background: alert.error.titleBackground
      },
      '&.warning': {
        background: alert.warning.titleBackground
      }
    },
    closeIcon: {
      padding: 0,
      '& svg': {
        fontSize: '16px',
        color: theme.corporate.secondaryColor
      }
    }
  }
}
